<div class="main-content">
  <div class="container-fluid">

    <div class="admin-page-header survey-dashboard-header">
      <div class="survey-dashboard-title">
        <div class="survey-dashboard-project" *ngIf="project && project.id">
          <img class="project-pic"
               src="https://hsbooster.eu{{ project.picture }}"
               onerror="this.src='/assets/img/1177568.png'" alt="">
          <div class="project-meta">
            <div class="project-line-1">
              <strong>{{ project.project_acronym }}</strong>
              <span class="project-name" *ngIf="project.name || project.surname">
                · <span *ngIf="project.title">{{ project.title }} </span>{{ project.name }} {{ project.surname }}
              </span>
            </div>
            <div class="project-line-2">
              <span *ngIf="project.organisation_type">{{ project.organisation_type }}</span>
              <span *ngIf="project.email"> · {{ project.email }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <survey-first-meeting></survey-first-meeting>
  </div>
</div>

<simple-alert [message]="alertMessage" [alert]="alertType" [(show)]="showAlert"></simple-alert>

